/**
 * Filtro por defecto para todas las tablas del sistema.
 * Centraliza: paginación inicial, orden por ID descendente (mayor a menor).
 *
 * Uso en páginas nuevas:
 *   const [filter, setFilter] = useState<MiFilters>(() =>
 *     getDefaultTableFilter<MiFilters>({ nombre: '', sociedad_id: null })
 *   );
 *
 * Las tablas deben usar siempre el componente global DefaultDataTable
 * (en components/default/DefaultDataTable.tsx), pasando columns, data, filter y setFilter.
 */

export const DEFAULT_TABLE_FILTER = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'desc' as const
};

/**
 * Devuelve el filtro base de tabla (paginación + orden por ID desc) y permite
 * extenderlo con los campos específicos del módulo (filtros de búsqueda, etc.).
 */
export function getDefaultTableFilter<T extends object>(
  overrides?: Partial<T>
): T & typeof DEFAULT_TABLE_FILTER {
  return {
    ...DEFAULT_TABLE_FILTER,
    ...(overrides ?? {})
  } as T & typeof DEFAULT_TABLE_FILTER;
}
